export const LOCAL_STORAGE_KEYS = {
  DISMISSED_TRIAL_BANNER_EXPIRE: 'dismissedTrialBannerExpire',
  DISMISSED_UPDATES: 'dismissedUpdates',
  WIDGET_BUILDER: 'widgetBubble_',
  DRAFT_MESSAGES: 'draftMessages',
  MESSAGE_REPLY_TO: 'messageReplyTo',
  MESSAGE_LAST_REPLY: 'lastReplyItem',
  PRIVATE_LAST_REPLY: 'privateLastReply',
  SECONDARY_MENU: 'secondaryMenu',
};
